import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { api } from '../../context/AuthContext';

// Admin: Standardbetrag der Rücklastschrift-Gebühr (wenn der Kontoauszug keine Bankgebühr enthält, z. B. bei Stripe-Raten)
export const RuecklastGebuehrEinstellung = () => {
  const [b, setB] = useState(null);
  const [msg, setMsg] = useState('');
  useEffect(() => { api.get('/admin/ruecklast-gebuehr').then((r) => setB(String(r.data.betrag).replace('.', ','))).catch(() => setB('')); }, []);
  const speichern = async () => {
    setMsg('');
    try { const r = await api.put('/admin/ruecklast-gebuehr', { betrag: Number(String(b).replace(',', '.')) }); setB(String(r.data.betrag).replace('.', ',')); setMsg('Gespeichert'); }
    catch (e) { setMsg(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
  };
  if (b === null) return <Loader2 className="w-4 h-4 animate-spin text-[#b8893d]" />;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="ruecklast-gebuehr-einstellung">
      <span className="relative"><input value={b} onChange={(e) => setB(e.target.value)} inputMode="decimal" className="w-28 pl-3 pr-7 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:border-[#b8893d]" data-testid="ruecklast-gebuehr-betrag" /><span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-sm text-gray-400">€</span></span>
      <button type="button" onClick={speichern} className="h-9 px-4 rounded-full bg-[#b8893d] text-white text-xs hover:bg-[#a5782f]" data-testid="ruecklast-gebuehr-speichern">Speichern</button>
      {msg && <span className="text-xs text-[#34536b]" data-testid="ruecklast-gebuehr-meldung">{msg}</span>}
    </div>
  );
};

export default RuecklastGebuehrEinstellung;
